<template>
  <div>
    <div v-if="(hasBillingInformation && (step === 0))">
      <omise-form
        ref="omiseForm"
        v-bind:credit="credit">
      </omise-form>
    </div>
    <div v-else>
      <div class="row pearls m-t-10">
        <div class="pearl current col-xs-6" v-bind:class="{ 'current' : (this.step === 0) }">
          <div class="pearl-icon"><i class="icon md-info" aria-hidden="true"></i></div>
          <span class="pearl-title">Billing Info</span>
        </div>
        <div class="pearl col-xs-6" v-bind:class="{ 'current' : (this.step === 1) }">
          <div class="pearl-icon"><i class="icon md-card" aria-hidden="true"></i></div>
          <span class="pearl-title">Credit Card</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <billing-information-form
            ref="billingInformationForm"
            v-if="(this.step === 0)"
            v-bind:team="team"
            v-on:save="onBillingInformationFormSaved"
            v-on:cancel="onBillingInformationFormCancel">
          </billing-information-form>
          <omise-form
            ref="omiseForm"
            v-if="(this.step === 1)"
            v-bind:credit="credit">
          </omise-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import OmiseForm from 'components/forms/OmiseForm';
import BillingInformationForm from 'components/forms/BillingInformationForm';

export default {
  components: {
    OmiseForm,
    BillingInformationForm,
  },
  props: {
    team: {
      type: Object,
    },
    credit: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {
      step: 0,
      hasBillingInformation: false,
    };
  },
  created: function() {
    this.fetchBillingInformation();
    this.eventHub.$on('hasBillingInformationUpdated', (hasBillingInformation) => {
      this.hasBillingInformation = hasBillingInformation;
    });
  },
  methods: {
    fetchBillingInformation: function() {
      axios.get(`/api/teams/${this.team.namespace}/billing/info`)
      .then((response) => {
        this.isLoading = false;

        if (Array.isArray(response.data)) {
          // no billing information
          this.hasBillingInformation = false;
        } else {
          this.hasBillingInformation = true;


          this.$nextTick(() => {
            this.billingInformation = response.data;
          });
        }

        this.$emit('loadChanged', false);

        // notify other components
        this.eventHub.$emit('hasBillingInformationUpdated', this.hasBillingInformation);
      })
      .catch(() => {
        this.isLoading = false;

        // error
        this.$emit('loadChanged', false);
      });
    },
    onBillingInformationFormSaved: function(newBillingInformation) {
      // move to omise form
      this.step = 1;

      // notify other components
      this.eventHub.$emit('billingInformationUpdated', newBillingInformation);
    },
    onBillingInformationFormCancel: function() {
      this.$emit('cancel');
    },
    clearForm: function() {
      this.step = 0;

      if (this.$refs.billingInformationForm) {
        this.$refs.billingInformationForm.clearForm();
      }

      if (this.$refs.omiseForm) {
        this.$refs.omiseForm.clearForm();
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// PaymentInformationForm.vue?52d6beb0